import { useEffect, useRef } from 'react';

export function usePrevious(value: any): number | undefined {
  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
